var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: _vm.loading ? "container-loading" : "",
      attrs: {
        fluid: !_vm.loading,
        "grid-list-lg": !_vm.loading,
        "fill-height": _vm.loading
      }
    },
    [
      !_vm.loading
        ? _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("custom-table", {
                    ref: "customTable",
                    attrs: {
                      "data-url": "/quotations/index",
                      "single-item-name": "quotation",
                      "plural-item-name": "quotations",
                      headers: _vm.headers,
                      freeze: _vm.updating,
                      breakpoint: 950,
                      clickable: ""
                    },
                    on: { click: _vm.view },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "row",
                          fn: function(props) {
                            return [
                              _c(
                                "td",
                                [
                                  _vm.checkNested(props.item, "client", "name")
                                    ? [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(props.item.client.name) +
                                            "\n                            "
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "text-center d-flex justify-center"
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(props.item.reference_number) +
                                          " "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: _vm.getChipColor(props.item),
                                            dark: "",
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.getChipContent(props.item)
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  props.item.holders.length
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass: "ml-2"
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                                        $mdiAccountStar\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "\n                                    Associated to a Policy Holder\n                                "
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  props.item.leads.length
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass: "ml-2"
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                                        $mdiBriefcaseAccount\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "\n                                    Associated to a Lead\n                                "
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  props.item.fo_id
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass: "ml-2"
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                                        $mdiAccountEdit\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "\n                                    Created by a Fulfilment Officer\n                                "
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  _vm.checkNested(
                                    props.item,
                                    "total_premium"
                                  ) &&
                                  _vm.checkNested(props.item, "monthly_payment")
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c("span", _vm._g({}, on), [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              props.item
                                                                .total_premium
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ])
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "\n                                    Total Monthly Payment: " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    props.item.monthly_payment
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: "card",
                          fn: function(props) {
                            return [
                              _c(
                                "td",
                                { staticClass: "v-data-table__mobile-row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-center w-full" },
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: _vm.getChipColor(props.item),
                                            dark: "",
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.getChipContent(props.item)
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.headers, function(
                                header,
                                headerIndex
                              ) {
                                return _c(
                                  "td",
                                  {
                                    key: headerIndex,
                                    staticClass: "v-data-table__mobile-row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "v-data-table__mobile-row__header"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(header.text) +
                                            "\n                            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "v-data-table__mobile-row__cell"
                                      },
                                      [
                                        header.value === "client_name"
                                          ? [
                                              _vm.checkNested(
                                                props.item,
                                                "client",
                                                "name"
                                              )
                                                ? [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          props.item.client.name
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                : _vm._e()
                                            ]
                                          : header.value === "reference_number"
                                          ? [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    props.item.reference_number
                                                  ) +
                                                  " "
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              props.item.holders.length
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {},
                                                                      "v-icon",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                $mdiAccountStar\n                                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                                            Associated to a Policy Holder\n                                        "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              props.item.leads.length
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {},
                                                                      "v-icon",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                $mdiBriefcaseAccount\n                                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                                            Associated to a Lead\n                                        "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              props.item.fo_id
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {},
                                                                      "v-icon",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                $mdiAccountEdit\n                                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                                            Created by a Fulfilment Officer\n                                        "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          : header.value === "premium"
                                          ? [
                                              _vm.checkNested(
                                                props.item,
                                                "total_premium"
                                              )
                                                ? [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm._f("currency")(
                                                            props.item
                                                              .total_premium
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("br")
                                                  ]
                                                : _vm._e()
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$refs.customTable.getCardValue(
                                                      props.item,
                                                      header.value
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  ]
                                )
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2991432837
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-layout",
            { attrs: { "justify-center": "", "align-center": "", column: "" } },
            [
              _c("v-progress-circular", {
                attrs: { size: 50, color: "secondary", indeterminate: "" }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }